import React, { useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { productDb } from "../firebaseProducts";
import Papa from "papaparse";
import { saveAs } from "file-saver";
import { query, limit, startAfter } from "firebase/firestore";

const FirestoreCsvExporter = () => {
  const [collectionChoice, setCollectionChoice] = useState("");
  const [loading, setLoading] = useState(false);

  // Map logical collection keys → actual Firestore collections + display name
  const collectionMap = {
    A: { display: "Kid's Accessories Menu", collections: ["kids-accessories-menu"] },
    B: { display: "Kid's Apparel Menu", collections: ["kids-apparel-menu"] },
    C: { display: "Adult's Accessories Menu", collections: ["adult-accessories-list-menu"] },
    D: { display: "Adult's Apparel Menu", collections: ["adult-list-menu"] },
    E: { display: "Drinkwear Menu", collections: ["drinkwear-menu"] },
    F: { display: "Full Kid's Accessories", collections: ["full-kids-accessories"] },
    G: { display: "Full Kid's White", collections: ["full-kids-white"] },
    H: { display: "Full Kid's Apparel", collections: ["kids-apparel"] },
    I: { display: "Kid's Apparel White Menu", collections: ["kids-apparel-white-menu"] },
    J: { display: "Full Adult Accessories", collections: ["full-adult-accessories"] },
    K: { display: "Full Adult Apparel", collections: ["adult-apparel"] },
    L: { display: "Full Drinkwear", collections: ["full-drinkwear"] }
  };

const downloadCSV = async () => {
  if (!collectionChoice) return alert("Select a collection");

  setLoading(true);
  const collectionsToFetch = collectionMap[collectionChoice].collections;
  const allData = [];
  const batchSize = 500;

  try {
    for (const colName of collectionsToFetch) {
      let lastDoc = null;
      while (true) {
        let queryRef = collection(productDb, colName);
        if (lastDoc) {
          queryRef = query(queryRef, startAfter(lastDoc), limit(batchSize));
        } else {
          queryRef = query(queryRef, limit(batchSize));
        }

        const snap = await getDocs(queryRef);
        if (snap.empty) break;

        snap.forEach((doc) => {
          allData.push({ id: doc.id, collection: colName, ...doc.data() });
        });

        lastDoc = snap.docs[snap.docs.length - 1];

        // ⏳ Prevent Firestore timeout
        await new Promise((r) => setTimeout(r, 300));
      }
    }

    if (allData.length === 0) {
      alert("No documents found.");
      setLoading(false);
      return;
    }

    // ✅ Use PapaParse to export
    const csv = Papa.unparse(allData);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, `firestore_export.csv`);
    alert(`✅ Exported ${allData.length} documents`);
  } catch (err) {
    console.error(err);
    alert("Error exporting CSV: " + err.message);
  }

  setLoading(false);
};


  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-2">Firestore CSV Exporter</h2>

      <select
        value={collectionChoice}
        onChange={(e) => setCollectionChoice(e.target.value)}
        className="w-full p-2 border mb-3"
      >
        <option value="">Select Collection</option>
        {Object.entries(collectionMap).map(([key, { display }]) => (
          <option key={key} value={key}>
            {display}
          </option>
        ))}
      </select>

      <button
        onClick={downloadCSV}
        disabled={loading}
        className="w-full bg-green-500 text-black p-2 rounded"
      >
        {loading ? "Exporting..." : "Download CSV"}
      </button>
    </div>
  );
};

export default FirestoreCsvExporter;
